

























































import { Component , Vue } from 'vue-property-decorator';
@Component({
    props: {
        fare: {
            type: Object,
            required: true,
        },
        showLessDeposit: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        subLinesPresent() {
            let present = false;
            this.$props.fare.lines.forEach((element: any) => {
                if (element.subLines && element.subLines.length) {
                    present = true;
                }
            });
            return present;
        },
    },
})
export default class FareDetails extends Vue {
    private showFareDetails = false;
}
